/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Container from "../../components/Container";
import NavigationHeader from "../../components/NavigationHeader";
import LoadingIndicator from "../../components/LoadingIndicator";
import EmptyView from "../../components/EmptyView";
import PackageItem, { normalizePackageInstance } from "../../components/booking/package/PackageItem";
import Stack from "../../components/ui/Stack";
import Icon from "../../components/ui/Icon";
import Button from "../../components/ui/Button";
import { usePackageInstances } from "../../lib/react-query/usePackages";
import { ROUTES } from "../../constants/constants";
import styled from "styled-components";
import Flex from "../../components/ui/Flex";

const PackagesGrid = styled(Stack)`
  grid-template-columns: repeat(auto-fill, minmax(min(314px, 100%), 1fr));
`;

const LoadMoreWrapper = styled(Flex)`
  margin-top: 1rem;
`;

const ClientPackages = () => {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = usePackageInstances();
  const navigate = useNavigate();

  const instances = useMemo(() => data?.pages?.flatMap(p => p.data) ?? [], [data]);

  return (
    <Container>
      <NavigationHeader title="My packages" back={ROUTES.HOME} clientLogin cart/>
      {isLoading ? (
        <LoadingIndicator page />
      ) : !instances.length ? (
        <Flex $direction="column" $align="center" style={{ margin: "2rem 0 10rem" }}>
          <EmptyView icon={Icon.BoxArchive} description="no_client_packages" />
          <Button title="Explore packages" onClick={() => navigate(ROUTES.PACKAGES)} />
        </Flex>
      ) : (
        <>
          <PackagesGrid $gap="0.5rem">
            {instances.map((instance) => (
              <PackageItem
                key={instance.id}
                pkg={normalizePackageInstance(instance)}
                readOnly
              />
            ))}
          </PackagesGrid>
          {hasNextPage && (
            <LoadMoreWrapper $justify="center">
              <Button title="Load more" variant="secondary" onClick={fetchNextPage} disabled={isFetchingNextPage} />
            </LoadMoreWrapper>
          )}
        </>
      )}
    </Container>
  );
};

export default ClientPackages;